import { render, staticRenderFns } from "./GoalForm.vue?vue&type=template&id=7b34b317&scoped=true&"
import script from "./GoalForm.vue?vue&type=script&lang=js&"
export * from "./GoalForm.vue?vue&type=script&lang=js&"
import style0 from "./GoalForm.vue?vue&type=style&index=0&id=7b34b317&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b34b317",
  null
  
)

export default component.exports